export default "__VITE_ASSET__BilzURBC__"